import React, { useEffect, useState } from 'react';
import styles from './loader.module.css';

const Loader = ({ messages = [] }) => {
    const [index, setIndex] = useState(0);

    useEffect(() => {
        if (!messages.length) return;

        const interval = setInterval(() => {
            setIndex(prev => (prev + 1) % messages.length);
        }, 1500); // 1.5 seconds

        return () => clearInterval(interval);
    }, [messages]);

    return (
        <React.Fragment>
            <div className={styles['loader-wrapper']}>
                <div className={styles.container}>
                    <div className={`${styles.row} row`}>
                        <img src="/img/iship-plus-logo.png" alt="iSHIP+" className={styles.logo} />
        
                        {/* Message section */}
                        {messages.length > 0 && (
                            <div className={`${styles['message']} text-muted`}>
                                {messages[index]}
                            </div>
                        )}

                        <div className={styles.line}>
                            <div className={styles.inner}></div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Loader;